import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories, MAIN_SITE_URL } from '@/data/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-900">{t('common.brand')}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">{t('common.footerAbout')}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">{t('common.footerQuickLinks')}</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('common.navGuides')}
                </Link>
              </li>
              <li>
                <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('common.visitMain')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">{t('common.footerCategories')}</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.slice(0, 8).map((c) => (
                <li key={c.id}>
                  <a
                    href={c.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-block rounded-md border border-background-300/60 bg-background-50 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {t(`cat.${c.id}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200/70 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t('common.footerDisclaimer')}</p>
          <p className="mt-3 text-xs text-foreground-500">
            © {new Date().getFullYear()} {t('common.brand')}. {t('common.footerRights')}
          </p>
        </div>
      </div>
    </footer>
  );
}